module.exports = __webpack_public_path__ + "img/logo.d4cc3ee8.svg";